import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const readAll = async (param) => {
  const { data } = await axios.get(`${baseUrl}/faq/categoryList`, {
    params: param,
  });
  return data;
};

const searchFaq = async (param) => {
  const { data } = await axios.get(`${baseUrl}/faq/search`, {
    params: param,
  });
  return data;
};

const createFaq = async (param) => {
  const { data } = await axios.post(`${baseUrl}/faq/create`, param);
  return data;
};

const faqApi = {
  readAll,
  searchFaq,
  createFaq,
};

export default faqApi;
